// extracted by mini-css-extract-plugin
export default {"group":"NotificationGroup_group__ri48P","groupTitle":"NotificationGroup_groupTitle__y44Bf"};